import { render, staticRenderFns } from "./RoomsMap.vue?vue&type=template&id=3d88363c&"
import script from "./RoomsMap.vue?vue&type=script&lang=ts&"
export * from "./RoomsMap.vue?vue&type=script&lang=ts&"
import style0 from "./RoomsMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d88363c')) {
      api.createRecord('3d88363c', component.options)
    } else {
      api.reload('3d88363c', component.options)
    }
    module.hot.accept("./RoomsMap.vue?vue&type=template&id=3d88363c&", function () {
      api.rerender('3d88363c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/RoomsMap.vue"
export default component.exports